// extracted by mini-css-extract-plugin
export var box = "_8s-1";
export var checked = "_8s-2";
export var descriptionSpacer = "_8s-9";
export var disabled = "_8s-3";
export var icon = "_8s-6";
export var input = "_8s-0";
export var labelSpacer = "_8s-8";
export var medium = "_8s-5";
export var small = "_8s-4";
export var text = "_8s-7";